import * as fabricanteActions from './fabricanteActions';

export const INITIAL_STATE = {
  fabricantes: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case fabricanteActions.SET_FABRICANTES:
      return { ...state, fabricantes: action.payload };

    default:
      return state;
  }
};
